/**
 * Japan's named editor. Shape and rules: src/data/editor.ts.
 * Details are the owner's (confirmed 2026-10-27): David, he/him. Only add
 * fields the owner has verified; leave an optional field out rather than
 * guessing. No personal sameAs: the Instagram account is the site's and stays
 * on the Organization (site.config.ts).
 * Site data files may only `import type` from src (no runtime imports).
 */
import type { EditorConfig } from '@/data/editor';

export const EDITOR: EditorConfig = {
  enabled: true,
  name: 'David',
  // Japanese pages show the katakana reading with the English name (owner, 2026-10-27).
  displayName: { en: 'David', ja: 'デイビッド（David）', ko: 'David' },
  alternateName: 'デイビッド',
  jobTitle: { en: 'Editor', ja: '編集者', ko: '편집자' },
  // Owner-approved bio (2026-10-27). Every fact is the owner's; edit all three together.
  description: {
    en: 'David is a skier and the editor of JapanSnowWatch. He lives between Japan and Korea and loves snow in all its forms. He started out on a snowboard and switched to skis for the love of two planks. He has ridden Hokkaido every season since 2012, with Niseko on the list every year, and Hakuba and Myoko since 2016. These days Hakuba is his favourite, and he likes finding Japan\'s smaller family-run ski areas. Since 2021 he has also ridden in Korea a few times each season, mostly at High1 and Mona Yongpyong. He writes the blog, checks the season calendar\'s opening dates against each resort\'s official announcements, and runs the site\'s Instagram. In summer he cycles and takes cars on track days at Inje Speedium and on Yeongjong Island in Incheon.',
    ja: 'デイビッド（David）はスキーヤーで、JapanSnowWatchの編集者です。日本と韓国を行き来しながら暮らし、あらゆる形の雪を愛しています。もともとはスノーボーダーでしたが、2本の板に惚れ込んでスキーに転向しました。2012年から毎シーズン北海道を滑り、ニセコには毎年通っています。2016年からは白馬と妙高でも滑っており、最近のお気に入りは白馬です。家族経営の小さなスキー場を巡るのも好きです。2021年からは韓国でも毎シーズン数回、主にハイワンとモナ龍平で滑っています。ブログの執筆、シーズンカレンダーのオープン日を各スキー場の公式発表と照らし合わせる確認、サイトのInstagram運営を担当しています。夏は自転車に乗り、インジェ・スピーディウムや仁川の永宗島で走行会に参加しています。',
    ko: 'David는 스키어이자 JapanSnowWatch의 편집자입니다. 일본과 한국을 오가며 살고, 눈이라면 어떤 모습이든 좋아합니다. 원래 스노보더였지만 스키 두 짝의 매력에 빠져 스키로 갈아탔습니다. 2012년부터 매 시즌 홋카이도에서 타고 있고, 니세코는 해마다 빠지지 않습니다. 2016년부터는 하쿠바와 묘코도 다니며, 요즘 가장 좋아하는 곳은 하쿠바입니다. 가족이 운영하는 작은 스키장을 찾아다니는 것도 즐깁니다. 2021년부터는 매 시즌 몇 차례 한국에서도 타는데, 주로 하이원과 모나용평입니다. 블로그를 쓰고, 시즌 캘린더의 개장일을 각 스키장 공식 발표와 대조해 확인하며, 사이트 인스타그램을 운영합니다. 여름에는 자전거를 타고, 인제 스피디움과 인천 영종도에서 서킷 주행을 즐깁니다.',
  },
  // Owner's photo (2026-10-27), metadata stripped. Alt text is the owner's.
  image: '/images/editor/david.jpg',
  imageWidth: 675,
  imageHeight: 900,
  imageAlt: {
    en: 'David and Sam on a chairlift in Japan',
    ja: 'チェアリフトに乗るデイビッド（David）とSam',
    ko: '리프트에 탄 David와 Sam',
  },
  age: 34, // as of 2026-10
};
